import React from "react";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Navigate, useNavigate, useOutletContext,Link } from "react-router-dom";
import MembGameSvcItemOdrLstInqApi from "Apis/MembGameSvcItemOdrLstInqApi";
import Pagination from "react-js-pagination";
import DatePicker from "react-datepicker";
import { ko } from 'date-fns/locale';
import GameSvcCdRelLstApi from "Apis/GameSvcCdRelLstApi";
import 'react-datepicker/dist/react-datepicker.css';
import MembGameLvdSvcMnyLpopUi from "./MembGameLvdSvcMnyLpopUi";


import MembNtfyMsgLstInqApi from "Apis/MembNtfyMsgLstInqApi";
import MembNtfyMsgCtxtInqApi from "Apis/MembNtfyMsgCtxtInqApi";
import MembNtfyMsgSttuChngApi from "Apis/MembNtfyMsgSttuChngApi";
import MembNtfyMsgCtxtUi from "Utils/MembNtfyMsgCtxtUi";
import MgpStore from "Stores/Store";
import { useDispatch, useSelector } from "react-redux";
import { SetNtfyMsgCnt } from 'Stores/LoginInfoReducer';
import ApiResultModal from "Components/ApiResultModal";



const MembNtfyMsgLstUi = () => {
    const langData:any = useOutletContext();
    const dispatch = useDispatch();
    const [pageState, setPageState] = useState(1);
    const [onePageSizeState,setOnePageSizeState] = useState();
    const [totPstdCntState,setTotPstdCntState] = useState(1);
    const [itemPchsOdrLstState,setItemPchsOdrLstState] = useState<any>();

    const [dpstAvlbState,setDpstAvlbState] = useState<any>([]);
    const [selectedSvcCdState,setselectedSvcCdState] = useState("");
    const [mdalState,setmdalState] = useState(false);
    const [ntfyMsgLstState,setNtfyMsgLstState] =useState<any>();
    const [ntfyMsgSnoState,setNtfyMsgSnoState] =useState("");
    const [ntfyMsgSttuCdState,setNtfyMsgSttuCdState] = useState("NOTREAD");
    const [ntfyRefreshToken,setNtfyRefreshToken] = useState(true);
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");

    const openResultModal = (message: string) => {
        setResultModalMessage(message);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
    };




    const navigate = useNavigate();
    var popupX = Math.round(window.screenX + (window.outerWidth/2) - (500/2));
    var popupY = Math.round(window.screenY + (window.outerHeight/2) - (765/2));
    const GameMnyPopFunc = (e:any)=>{
        window.open(e,"_blank","width=500,height=765 left="+popupX+"top="+popupY);
    }
    const handlePageChange = (pageState:any) => {
        setPageState(pageState);
        MembNtfyMsgLstInqApi(pageState,ntfyMsgSttuCdState).then((resp)=>{
            setNtfyMsgLstState(resp.apiBody.ntfyMsgLst)
            setPageState(resp.apiBody.nowPageNo)
            setTotPstdCntState(resp.apiBody.totMsgCnt)
            setOnePageSizeState(resp.apiBody.nowPageMsgCnt)
            try { if (resp && resp.apiBody && typeof resp.apiBody.notReadMsgCnt !== 'undefined') dispatch(SetNtfyMsgCnt(resp.apiBody.notReadMsgCnt)); } catch (e) {}
        })
      };
    const MdalOpenerFunc =(e:string|null) => {
        setmdalState(!mdalState);
        setNtfyRefreshToken(!ntfyRefreshToken)
    }
    useEffect(()=>{
        MembNtfyMsgLstInqApi(pageState,ntfyMsgSttuCdState).then((resp)=>{
            setNtfyMsgLstState(resp.apiBody.ntfyMsgLst)
            setPageState(resp.apiBody.nowPageNo)
            setTotPstdCntState(resp.apiBody.totMsgCnt)
            setOnePageSizeState(resp.apiBody.nowPageMsgCnt)
            try { if (resp && resp.apiBody && typeof resp.apiBody.notReadMsgCnt !== 'undefined') dispatch(SetNtfyMsgCnt(resp.apiBody.notReadMsgCnt)); } catch (e) {}
        })
        
    },[MgpStore.getState().LangSetState.Lang,ntfyRefreshToken])
    const NtfyMsgLstChngFunc =(ntfyMsgSttuCd:string) => {
        setPageState(1);
        MembNtfyMsgLstInqApi(1,ntfyMsgSttuCd).then((resp)=>{
            setNtfyMsgLstState(resp.apiBody.ntfyMsgLst)
            setTotPstdCntState(resp.apiBody.totMsgCnt)
            setOnePageSizeState(resp.apiBody.nowPageMsgCnt)
            setPageState(resp.apiBody.nowPageNo)
            setNtfyMsgSttuCdState(ntfyMsgSttuCd);
            try { if (resp && resp.apiBody && typeof resp.apiBody.notReadMsgCnt !== 'undefined') dispatch(SetNtfyMsgCnt(resp.apiBody.notReadMsgCnt)); } catch (e) {}

        })
    }
    const MsgReadYFunc = (value:string)=> {
        MembNtfyMsgSttuChngApi(value,"READ").then((resp)=>{
            setNtfyRefreshToken(!ntfyRefreshToken)
        })
    }
      const MsgDeleFunc = (value:string)=> {
        MembNtfyMsgSttuChngApi(value,"DELE").then((resp)=>{
            setNtfyRefreshToken(!ntfyRefreshToken)
            if (mdalState === true) {
                setmdalState(!mdalState);
            }
            // list refresh triggered by ntfyRefreshToken will update unread count via useEffect
        })
    }
    const NtfyMsgCtxtMdalFunc =(msgSno:string) => {
        setNtfyMsgSnoState(msgSno);
        setmdalState(!mdalState);
    }
    const NtfyMsgLinkFunc = (msgSno:string) => {
        MembNtfyMsgCtxtInqApi(msgSno).then((resp)=>{
            switch(resp.apiHdr.code){
                case "MEMB0000":
                    window.open(resp.apiBody.msgCtxt,"_blank");
                break;
                default:
                    openResultModal(`${resp.apiHdr.msg}`);
                break;
            }
            setNtfyRefreshToken(!ntfyRefreshToken);
        });
    }
    return(
        <>
        <ApiResultModal
            open={resultModalOpen}
            message={resultModalMessage}
            onClose={closeResultModal}
        />
        <Helmet>
            <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.MYPAGE_NTFY_MSG_PAGE_TITL_00}`}</title>
        </Helmet>
        <div className="container1300 BgW pb200">
            <div className="myPageSubTitlWrap">
                <p className="myPageCtxtTitl">{langData&&langData.MYPAGE_NTFY_MSG_PAGE_TITL_00}</p>
            </div>
            <div>
                <div className="myGameSvcMnyWrap membNtfyMsgTopMenuWrap">
                    <ul className="membNtfyMsgTopMenu">
                        <li className={ntfyMsgSttuCdState === "NOTREAD" ? "active" : ""} onClick={()=>NtfyMsgLstChngFunc("NOTREAD")}>
                            <p>{langData&&langData.MYPAGE_NTFY_MSG_UNREAD_BTN_00}</p>
                        </li>
                        <li className={ntfyMsgSttuCdState === "READ" ? "active" : ""} onClick={()=>NtfyMsgLstChngFunc("READ")}>
                            <p>{langData&&langData.MYPAGE_NTFY_MSG_READ_BTN_00}</p>
                        </li>
                        <li className={ntfyMsgSttuCdState === "ALL" ? "active" : ""} onClick={()=>NtfyMsgLstChngFunc("ALL")}>
                            <p>{langData&&langData.MYPAGE_NTFY_MSG_ALL_BTN_00}</p>
                        </li>
                    </ul>
                    <div className="membNtfyMsgTopMenuBtn">
                        <button onClick={()=>MsgReadYFunc("0")}>
                            <p>{langData&&langData.MYPAGE_NTFY_MSG_ALL_READ_00}</p>
                        </button>
                        <button onClick={()=>MsgDeleFunc("0")}>
                            <p>{langData&&langData.MYPAGE_NTFY_MSG_ALL_DELE_00}</p>
                        </button>
                    </div>
                </div>
                <div className="myGameSvcMnyCtxtWrap">
                    <div className="myGameSvcMnydpstOdrLstWrap ntfyMsgLstWrap">
                        
                        <ul>
                            <li className="lstTItlWrap col206020 moNone">
                                <p className="ctntTitlTxt moNone">{langData&&langData.MYPAGE_NTFY_MSG_CTGR_LBL_00}</p>
                                <p>{langData&&langData.MYPAGE_NTFY_MSG_CTXT_LBL_00}</p>
                                <p>{langData&&langData.MYPAGE_MNY_LST_DTIME_LBL_00}</p>
                            </li>
                        {ntfyMsgLstState&&ntfyMsgLstState.length != 0? 
                            <>
                            {ntfyMsgLstState&&ntfyMsgLstState.map((key:any) => (
                                <>
                                {key.msgKindCd =="LNK"?
                                <li onClick={()=>{NtfyMsgLinkFunc(key.msgSno)}}>
                                    {/* <p>{key.itemUnit}</p> */}
                                    <p className="moNone">{key.msgCtgrNm}</p>
                                    <p className="textL">{key.msgTitl}</p>
                                    {/* <p>{key.msgKindCd}</p> */}
                                    <p className="moNone">{key.ntfyRecvDtime}</p>
                                </li>
                                :
                                <li onClick={()=>NtfyMsgCtxtMdalFunc(key.msgSno)}>
                                    {/* <p>{key.itemUnit}</p> */}
                                    <p className="moNone">{key.msgCtgrNm}</p>
                                    <p className="textL">{key.msgTitl}</p>
                                    {/* <p>{key.msgKindCd}</p> */}
                                    <p className="moNone">{key.ntfyRecvDtime}</p>
                                </li>
                                }
                                </>
                            ))}
                            </>
                            :
                        <li className="noDataLi">
                            <p>{langData&&langData.MYPAGE_NTFY_MSG_NO_DATA_00}</p>
                        </li>
                        }
                        </ul>
                        {ntfyMsgLstState&&ntfyMsgLstState.length != 0? 
                        <div className="ctntPageWrap">
                            <Pagination
                                activePage={pageState}
                                itemsCountPerPage={8}
                                totalItemsCount={totPstdCntState}
                                pageRangeDisplayed={5}
                                firstPageText={""}
                                linkClassFirst={"pagenationBtn pagenationFirstBtn"}
                                prevPageText={""}
                                linkClassPrev={"pagenationBtn pagenationPrevBtn"}
                                nextPageText={""}
                                linkClassNext={"pagenationBtn pagenationNextBtn"}
                                lastPageText={""}
                                linkClassLast={"pagenationBtn pagenationLastBtn"}
                                onChange={handlePageChange}
                            />
                        </div>
                        :
                        <></>
                        }
                    </div>
                </div>
            </div>
        </div>
        {mdalState&&(
            <div className="mdalWrap">
                <div className="mdalBg" onClick={()=>MdalOpenerFunc(null)}></div>
                <div className="mdalCtxtWrap contaniner700">
                    <div className="ntfyMdalCtxtInner">
                        <MembNtfyMsgCtxtUi msgSno={ntfyMsgSnoState} MsgDeleFunc={MsgDeleFunc} />
                        <div className="dpstLstMdalClose">
                            <button onClick={()=>MsgDeleFunc(ntfyMsgSnoState)}>
                                <p>{langData&&langData.MYPAGE_NTFY_MSG_DELE_BTN_00}</p>
                            </button>
                            <button  className="mdalCloseBtn"onClick={() => MdalOpenerFunc(null)}>
                                <p>{langData&&langData.MYPAGE_NTFY_MSG_CLOS_BTN_00}</p>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )}
        </>
    )
}

export default MembNtfyMsgLstUi;